// Centralised BJC site content — easy editing later
export const BRAND = {
  name: "Bharat Jeswani Consulting",
  shortName: "BJC",
  tagline: "Specialist Global Advisory in AML, Financial Crime & Regulatory Defence",
  subBrand: "Global AML Consultants",
  email: "bharat@bharatjeswani.com",
  founder: "Bharat Jeswani",
  founderPhoto: "/assets/founder.jpg",
};

export const NAV_ITEMS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Industries", to: "/industries" },
  { label: "Insights", to: "/insights" },
  { label: "Speaking", to: "/speaking" },
  { label: "Partner", to: "/partner" },
  { label: "Contact", to: "/contact" },
];

export const CAPABILITIES = [
  {
    id: "aml-audit",
    title: "AML Audit & Independent Review",
    summary:
      "Independent validation of AML control effectiveness, transaction monitoring systems, and compliance frameworks.",
    points: [
      "AML audits",
      "Transaction monitoring effectiveness review",
      "Sanctions and screening review",
      "KYC / CDD / EDD assessment",
      "Independent validation of controls",
    ],
  },
  {
    id: "aml-compliance",
    title: "AML Compliance & Program Design",
    summary:
      "Design of scalable, regulator-ready AML frameworks, governance structures, and control environments.",
    points: [
      "Enterprise AML frameworks",
      "Risk assessment methodologies",
      "Customer risk rating models",
      "Governance structures",
      "Control architecture",
    ],
  },
  {
    id: "fincrime-tech",
    title: "Financial Crime Technology Advisory",
    summary:
      "Assessment and optimisation of AML systems, data quality, and transaction monitoring effectiveness.",
    points: [
      "Tool selection support",
      "System effectiveness review",
      "Scenario optimisation",
      "Data quality assessment",
      "AI governance in AML",
    ],
  },
  {
    id: "regulatory-defence",
    title: "Regulatory Defence & Remediation",
    summary:
      "Structured response to regulatory observations, control failures, and remediation programs.",
    points: [
      "Regulatory response strategy",
      "Remediation planning",
      "Independent validation",
      "Board and audit committee advisory",
    ],
  },
];

export const ADDITIONAL_CAPABILITIES = [
  "Fraud Risk Management",
  "Forensic Due Diligence",
  "Investigation Strategy Support",
];

export const INDUSTRIES = [
  {
    title: "Banks & NBFCs",
    body: "Strengthening AML controls, governance, and regulatory readiness.",
  },
  {
    title: "Fintechs & Payments",
    body: "Designing scalable AML frameworks for high-growth environments.",
  },
  {
    title: "Digital Assets / VASPs",
    body: "Bringing institutional AML rigor to emerging financial ecosystems.",
  },
  {
    title: "Exchange Houses & Remittance",
    body: "Enhancing transaction monitoring and cross-border risk controls.",
  },
  {
    title: "Capital Markets & Insurance",
    body: "Independent review of AML frameworks and regulatory compliance.",
  },
  {
    title: "Trade-Based & Cross-Border",
    body: "Advisory on financial crime risks in complex transaction environments.",
  },
];

export const ENGAGE_TRIGGERS = [
  "AML controls need independent validation",
  "Transaction monitoring systems are underperforming",
  "Regulatory observations require structured response",
  "Compliance effectiveness is unclear",
  "Growth is outpacing control maturity",
  "Board-level clarity on financial crime risk is required",
];

export const WHY_BJC = [
  {
    title: "Specialist Focus",
    body: "Deep, exclusive concentration on AML and financial crime — not a side practice.",
  },
  {
    title: "Regulator-Aware",
    body: "Advisory shaped by an understanding of how regulators read controls and evidence.",
  },
  {
    title: "Independent Judgement",
    body: "Unbiased perspective unconstrained by audit, technology, or product affiliations.",
  },
  {
    title: "Technology Fluency",
    body: "Strong integration of monitoring systems, data, and AI governance into control design.",
  },
  {
    title: "Senior-Led",
    body: "Engagements delivered by experienced specialists — not staffed down to juniors.",
  },
  {
    title: "Cross-Border Lens",
    body: "Practical understanding of financial crime risk across India, Middle East, and APAC.",
  },
];

export const SPEAKING_TOPICS = [
  "AML effectiveness and control frameworks",
  "Transaction monitoring failures",
  "AI in financial crime compliance",
  "Regulatory defence strategies",
  "Fraud and financial crime case studies",
];

export const SPEAKING_FORMATS = [
  { title: "Conferences", body: "Keynotes and panel sessions at global financial crime forums." },
  { title: "Workshops", body: "Practitioner-focused, scenario-led training sessions." },
  { title: "Board Briefings", body: "Concise, decision-grade briefings for boards and audit committees." },
  { title: "Corporate Training", body: "Tailored programs for in-house compliance and risk teams." },
];

export const PARTNER_TYPES = [
  { title: "Audit Firms", body: "Specialist AML and forensic depth to extend audit propositions." },
  { title: "Law Firms", body: "Subject-matter advisory in financial crime investigations and regulatory matters." },
  { title: "Consulting Firms", body: "Domain partnership for AML, financial crime, and regulatory engagements." },
  { title: "Technology Providers", body: "Independent advisory on monitoring effectiveness and implementation." },
];
